import React from 'react';
import { Save } from 'lucide-react';
import { Editor as TinyMCEEditor } from '@tinymce/tinymce-react';

const InfoTextTab = ({ calculationInfo, setCalculationInfo, saveCalculationInfo, savingInfo }) => {
  return (
    <>
      <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '1rem' }}>Allgemeiner Informationstext</h3>
      <p style={{ color: '#666', marginBottom: '1rem', fontSize: '0.9rem' }}>
        Dieser Text wird an verschiedenen Stellen im Rechner angezeigt (z.B. Förderungs-Informationen, Berechnungsdetails auf der Ergebnisseite). Der Nutzer kann ihn über einen "ℹ️ Weitere Informationen"-Link aufrufen.
      </p>
      
      <div style={{ marginBottom: '1rem' }}>
        <TinyMCEEditor
          apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
          value={calculationInfo}
          onEditorChange={(content) => setCalculationInfo(content)}
          init={{
            height: 500,
            menubar: true,
            plugins: [
              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime', 'media', 'table', 'preview', 'help', 'wordcount'
            ],
            toolbar: 'undo redo | blocks | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media | removeformat | code | help',
            content_style: 'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; font-size: 14px; line-height: 1.6; }',
            image_advtab: true,
            automatic_uploads: false
          }}
        />
      </div>
      
      <button 
        onClick={saveCalculationInfo}
        disabled={savingInfo}
        className="btn-primary"
        style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
      >
        <Save size={16} />
        {savingInfo ? 'Speichern...' : 'Speichern'}
      </button>
    </>
  );
};

export default InfoTextTab;
